import React, { useContext } from 'react';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';
import Avatar from '@mui/material/Avatar';
import { Link, useLocation, useNavigate } from 'react-router';
import { Business } from '@mui/icons-material';
import Phone from '@mui/icons-material/Phone';
import AuthContext from '../context/AuthContext';
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
const drawerWidth = 240;

const Sidebar = () => {
    const location = useLocation();
    const { userInfo,logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/login");
    };

    return (
        <MuiDrawer
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    backgroundColor: '#1e1e2f',
                    color: 'white',
                },
            }}
            variant="permanent"
            anchor="left"
            className='container'
        >
            <AppBar position="static" color="transparent" elevation={0}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography
                        variant="h6"
                        noWrap
                        component={Link}
                        to="/contab-admin"
                        sx={{
                            textDecoration: "none",
                            color: "inherit",
                            fontWeight: "bold",
                            "&:hover": {
                                textDecoration: "underline",
                            },
                        }}
                    >
                        Admin
                    </Typography>

                    <Button color="error" variant="outlined" onClick={handleLogout}>
                        Logout
                    </Button>
                </Toolbar>
            </AppBar>

            {/* User Profile */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
                <Avatar alt="Admin" src="/static/images/avatar.jpg" />
                <Typography variant="body2" mt={1}>{userInfo?.email}</Typography>
                <Typography variant="caption" color="gray">Admin</Typography>
            </Box>

            <List>
                {/* Dashboard */}
                <ListItemButton component={Link} to="/contab-admin" selected={location.pathname === "/contab-admin"}>
                    <ListItemIcon>
                        <DashboardIcon style={{ color: 'white' }} />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItemButton>

                {/* Document */}
                <ListItemButton component={Link} to="/contab-admin/document" selected={location.pathname === '/contab-admin/document'}>
                    <ListItemIcon>
                        <DescriptionIcon style={{ color: 'white' }} />
                    </ListItemIcon>
                    <ListItemText primary="Document" />
                </ListItemButton>

                {/* Users */}
                <ListItemButton component={Link} to="/contab-admin/user" selected={location.pathname === '/contab-admin/user'}>
                    <ListItemIcon>
                        <PeopleIcon style={{ color: 'white' }} />
                    </ListItemIcon>
                    <ListItemText primary="Users" />
                </ListItemButton>

                {/** Societe */}
                <ListItemButton component={Link} to="/contab-admin/society" selected={location.pathname === '/contab-admin/society'}>
                    <ListItemIcon>
                        <Business style={{ color: 'white' }} />
                    </ListItemIcon>
                    <ListItemText primary="Societés" />
                </ListItemButton>

                {/** Call to remember */}
                <ListItemButton component={Link} to="/contab-admin/call-remember" selected={location.pathname === '/contab-admin/call-remember'}>
                    <ListItemIcon>
                        <Phone style={{ color: 'white' }} />
                    </ListItemIcon>
                    <ListItemText primary="Se faire rappeler" />
                </ListItemButton>
            </List>
        </MuiDrawer>
    );
};

export default Sidebar;